<template>
  <div id="the-home">
    <v-dialog v-model="showPasswordExpiryWarning" persistent max-width="600">
      <v-card>
        <v-card-title
          class="text-h5 d-flex align-center"
          :class="
            urgencyLevel === 'critical'
              ? 'error white--text'
              : 'warning white--text'
          "
        >
          <v-icon large color="white" class="mr-3"> mdi-alert-circle </v-icon>
          {{ $t("global.msg.password-expire-title") }}
        </v-card-title>

        <v-card-text class="pt-6 pb-4">
          <div class="text-body-1 mb-4">
            <span v-if="daysRemaining !== null">
              {{ $t("global.msg.password-expire", [daysRemaining]) }}
            </span>
            <span v-else>
              {{ $t("global.msg.password-expire-generic") }}
            </span>
          </div>

          <v-alert
            :type="urgencyLevel === 'critical' ? 'error' : 'warning'"
            text
            dense
            class="mb-0"
          >
            {{ $t("global.msg.password-expire-action") }}
          </v-alert>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn text @click="dismissWarning">
            {{ $t("global.msg.remind-later") }}
          </v-btn>
          <v-btn
            :color="urgencyLevel === 'critical' ? 'error' : 'warning'"
            dark
            @click="changePassword"
          >
            <v-icon left>mdi-lock-reset</v-icon>
            {{ $t("global.msg.change-password-now") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <change-password-dialog v-model="showChangePassword" @input="onInput" />
  </div>
</template>

<script>
import ChangePasswordDialog from "@/components/ChangePasswordDialog";

export default {
  name: "AppHome",

  components: {
    ChangePasswordDialog,
  },

  data() {
    return {
      showPasswordExpiryWarning: false,
      showChangePassword: false,
    };
  },

  computed: {
    daysRemaining() {
      return this.$store.state.passwordValidityDays;
    },
    urgencyLevel() {
      if (this.daysRemaining !== null && this.daysRemaining <= 3) {
        return "critical";
      }
      return "warning";
    },
  },

  methods: {
    dismissWarning() {
      this.showPasswordExpiryWarning = false;
      this.navigateToDefaultRoute();
    },
    changePassword() {
      this.showPasswordExpiryWarning = false;
      this.showChangePassword = true;
    },
    navigateToDefaultRoute() {
      if (this.$store.state.bpInstReadPermission) {
        this.$router.push({ name: "BP instances" });
      } else if (this.$store.state.runReadPermission) {
        this.$router.push({ name: "Runs" });
      } else {
        this.$router.push({ name: "Modules" });
      }
    },

    onInput(event) {
      if (!event) {
        this.navigateToDefaultRoute();
      }
    },
  },

  created() {
    if (this.$store.state.showPasswordExpiryWarning) {
      this.showPasswordExpiryWarning = true;
    } else {
      this.navigateToDefaultRoute();
    }
  },
};
</script>
